import { Divider, Form, Select, Input, Button, Image, message  } from "antd"
import { get, post } from "library/endpoints"
import { useEffect, useState } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import UploadFile from "./components/UploadFile"


const HelpDeskModal = (props) => {

  const [categories, setCategories] = useState([])
  const [billings, setBillings] = useState([])
  const [photo, setPhoto] = useState(null)
  const [productPhoto, setProductPhoto] = useState(null)

  useEffect(() => {
    fetchData()    
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
      const responseCategories = await get(`/frontend/help-desk/categories`);
      const responseBills = await get(`/frontend/basket/bills`);
      setCategories(responseCategories.data)
      setBillings(responseBills.data)
    } catch (error) {
      console.log(error)
    }
  }

  const onFinish = async (values) => {
    try {
      await post(`/frontend/help-desk`, {
        ...values,
        photo,
        product_photo: productPhoto
      })
      message.success('Merci, nous reviendrons vers vous très prochainement')
      props.onOk()
    } catch (error) {
      message.error('Une erreur s est produite lors de la soumission de votre formulaire')      
    }
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Type de problème rencontré"
          name="_category"
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Select>
            {
              categories.map((category) => (
                <Select.Option value={category._id} key={category._id}>{category.category.fr}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>

        <Form.Item
          label="Facture concernée"
          name="_billing"
        >
          <Select>
            {
              billings.map((billing) => (
                <Select.Option value={billing._id} key={billing._id}>{billing.invoice_label}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>

        <Form.Item
          label="Votre message"
          name="message"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.TextArea autoSize />
        </Form.Item>

        <div style={{ marginBottom: 20 }}>
          <div>
            <UploadFile label={'Photo du défaut constaté'} client={props.auth.user} callback={(url) => setPhoto(url)} auth={props.auth}/>
          </div>
          {
            photo && (
              <Image src={`${process.env.REACT_APP_S3_URL}${photo}`} width={100} style={{ margin: 10 }} />
            )
          }
        </div>

        <div style={{ marginBottom: 20 }}>
          <div>
            <UploadFile label={'Photo générale du produit'} client={props.auth.user} callback={(url) => setProductPhoto(url)} auth={props.auth}/>
          </div>
          {
            productPhoto && (
              <Image src={`${process.env.REACT_APP_S3_URL}${productPhoto}`} width={100} style={{ margin: 10 }} />
            )
          }
        </div>
      
        <Divider />

        <Form.Item
          style={{ marginTop: 20 }}
        >
          <Button type="primary" htmlType="submit">
            Envoyer
          </Button>
          <Button type="link" onClick={props.handleOnCancelFormView}>Annuler</Button>
        </Form.Item>
      </Form>
      </>
    
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(HelpDeskModal))